<template lang="pug">
el-dialog.dialog(
  width="99%"
  :visible="vacation.show"
  :close-on-click-modal="false"
  :close-on-press-scape="false"
  :show-close="false"
)
  h1 Alerta de Férias!
  p.detail O{{ plural }} funcionário{{ plural }} abaixo {{ plural ? 'possuem' : 'possui' }} férias agendadas, e seus clientes ainda não foram submetidos a solicitação de substituição de vendedor.
  ul.employees
    li(v-for="vacation in vacation.vacations")
      p.bold {{ vacation.employee.employeeCode }} - {{ vacation.employee.name }}
      p.tab Período de férias:&nbsp;
        span.bold {{ formatDate(vacation.date.start) }} a {{ formatDate(vacation.date.end) }}
      p.tab Clientes precisando de substituição de vendedor:&nbsp;
        span.bold {{ vacation.totalClients - vacation.transferedClients }} clientes
  template(v-slot:footer)
    el-button(@click="closeModal") Ok
    el-button(type="primary" @click="goToTransfers") Ir para substituição de vendedor
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'VacationDialog',
  computed: {
    ...mapState({
      vacation: state => state.vacation,
    }),
    plural() {
      return this.vacation.vacations.length > 1 ? 's' : ''
    },
  },
  methods: {
    ...mapMutations('vacation', ['setShowVacationsAlert']),
    closeModal() {
      this.setShowVacationsAlert(false)
    },
    goToTransfers() {
      this.$router.push('/transferencia')
      this.closeModal()
    },
    formatDate(date) {
      return this.$moment.utc(date).format('DD/MM/YYYY')
    },
  },
}
</script>

<style lang="sass" scoped>
.dialog
  z-index: 3001 !important
  background: #00000044
  &::v-deep
    .el-dialog__body
      padding-top: 0px
      padding-bottom: 16px
  h1
    color: var(--primaryColor)
    font-weight: bold
    font-size: 1.5rem
    margin-bottom: 20px
  .employees
    padding: 5px 0px
  p
    padding: 3px 0px
  .detail
    font-size: 1rem
    word-break: normal
    line-height: 1.3rem
  .tab
    padding-left: 10px
  .bold
    font-weight: bold
  li:not(:last-child)
    margin-bottom: 16px
</style>
